import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';


export class ProjectDataView extends Component {

	render() {
		const { typeOfROM, projectTitle, projectNumber, status } = this.props;
		return (
			<Card>
				<CardHeader title="Project Data" className='romis-card-header' />
				<CardContent>
					
					<TextField
						label="Type of ROM"
						value={typeOfROM}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
					/>

					<TextField
						label="Project Title :"
						value={projectTitle}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
					<TextField
						label="Project Number :"
						value={projectNumber}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
					<TextField
						label="Status :"
						value={status}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
				</CardContent>

			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectDataView.js